import { Boundaries } from "@planzone/core";
import { Identifiable, Resource } from "@planzone/dto";

function handleRemoveTagRequest(
  resource: Identifiable<Resource>,
  { removableId, tag }: Boundaries["removeTag"]["request"],
): Identifiable<Resource> {
  return resource.uuid === removableId
    ? {
        ...resource,
        tags: resource.tags.filter(({ name }) => name !== tag.name),
      }
    : resource;
}

function handleRemoveTagSuccess(
  resource: Identifiable<Resource>,
  { removableId, tag }: Boundaries["removeTag"]["success"],
): Identifiable<Resource> {
  return resource.uuid === removableId
    ? {
        ...resource,
        tags: resource.tags.filter(({ name }) => name !== tag.name),
      }
    : resource;
}

function handleRemoveTagFailure(
  resource: Identifiable<Resource>,
  { removableId, tag }: Boundaries["removeTag"]["failure"],
): Identifiable<Resource> {
  return resource.uuid === removableId
    ? {
        ...resource,
        tags: resource.tags ? [...resource.tags, tag] : [tag],
      }
    : resource;
}

export {
  handleRemoveTagRequest,
  handleRemoveTagSuccess,
  handleRemoveTagFailure,
};
